module.exports = __webpack_public_path__ + "img/banner.0689641d.png";